import { useContext } from "react";
import { StaticResourcesContext } from "../../context/StaticResources/StaticResourcesContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";

const useQuickMessages = () => {
    const { fetchQuickMessages, quickMessagesCache, loadingStates } = useContext(StaticResourcesContext);
    const { user } = useContext(AuthContext);

    const refreshList = async () => {
        return await fetchQuickMessages(user?.id, true);
    };

    const save = async (data) => {
        const formData = data._formData;
        delete data.id
        const payload = formData || data;
        const { data: responseData } = await api.request({
            url: '/quick-messages',
            method: 'POST',
            data: payload,
        });
        const refreshed = await refreshList();
        return { saved: responseData, list: refreshed };
    }

    const update = async (data) => {
        const formData = data._formData;
        const payload = formData || data;
        const { data: responseData } = await api.request({
            url: `/quick-messages/${data.id}`,
            method: 'PUT',
            data: payload,
        });
        const refreshed = await refreshList();
        return { updated: responseData, list: refreshed };
    }

    const deleteRecord = async (id) => {
        const { data } = await api.request({
            url: `/quick-messages/${id}`,
            method: 'DELETE'
        });
        const refreshed = await refreshList();
        return { deleted: data, list: refreshed };
    }

    const list = async (params, forceUpdate = false) => {
        console.log("🚀 useQuickMessages.list() - usando cache inteligente");
        return await fetchQuickMessages(params?.userId, forceUpdate);
    }

    return {
        save,
        update,
        deleteRecord,
        list,
        quickMessagesCache,
        loading: loadingStates.quickMessages
    }
}

export default useQuickMessages;